import { Component } from '@angular/core';
import { DetailInfoTypeComponent } from '../detail-info-type.component';

@Component({
    selector: 'detail-info-numeric-textbox',
    templateUrl: './detail-info-numeric-textbox.component.html',
    standalone: false
})
export class DetailInfoNumericTextboxComponent extends DetailInfoTypeComponent {
  ngOnInit() {
    super.ngOnInit();
  }
}